// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/'
import $ from 'jquery'
import  VueResource  from 'vue-resource'
import VueLazyLoad from 'vue-lazyload'
import Notification from './components/notification'
import router from './router'
import App from './App'

Vue.use(VueLazyLoad,{
  error:'./static/loading.png',
  loading:'./static/loading.png'
})
Vue.use(VueResource)
Vue.use(Notification)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  created(){
    if(typeof window!=="undefined"){
      require('./utils/adaptation.js')
      const api = require('./utils/httpSrv.js')
      require('./common/websocketSrv')
      Vue.prototype.api = api
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js